import { CommonModule } from '@angular/common';
import { Component, computed, inject, signal } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { UiModule } from '@components/ui/ui-module';
import { CardSet, Card as CardIndex } from '@models/card.model';
import { BinderService } from '@services/binder.service';
import { Card } from '@services/card.service';
import { Router } from '@services/route.service';
import { forkJoin, switchMap } from 'rxjs';

@Component({
  selector: 'lgb-stats-serie',
  imports: [
    CommonModule,
    RouterModule,
    UiModule
  ],
  templateUrl: './stats-serie.html',
  styleUrl: './stats-serie.css',
})
export class StatsSerie {
  //service
  readonly cardS=inject(Card);
  readonly route=inject(ActivatedRoute);
  readonly router=inject(Router);
  readonly binderS=inject(BinderService);

  //data
  readonly cardSet=signal<CardSet>(null);
  readonly cards=signal<CardIndex[]>([]);
  readonly cardCollect=signal<CardIndex[]>([]);

  //ui
  readonly loading=signal(false);
  readonly progress=computed(() => this.getPercent());

  constructor(){
    this.loading.set(true);
    this.route.paramMap
      .pipe(
        switchMap(params => forkJoin({
          cardSet: this.cardS.getCardSet(params.get('cardSet')),
          cards: this.cardS.getCardBySet(params.get('cardSet')),
          cardBinder: this.binderS.getCardStats(params.get('cardSet'))
        }))
      )
      .subscribe(result => {
        this.cardSet.set(result.cardSet);
        this.cards.set(result.cards);
        this.cardCollect.set(result.cardBinder);
        this.loading.set(false);
      });
  }

  isInCollect(card: string){
    return (this.cardCollect().find(c => c.ident==card)!=null);
  }

  getPercent(){
    let result: number=0;
    if(!this.cardSet().nbCard)
      result=100;
    else
      result=this.cardCollect().length*100/this.cardSet().nbCard;
    return result;

  }
}
